import { cn } from "@/utils";
import type { StediSubscriberFieldOverlay } from "@/types/intake";

function overlayValue(value: string): string {
  return value.trim() || "—";
}

function overlayLine(overlay: StediSubscriberFieldOverlay): string {
  const submitted = overlayValue(overlay.submitted);
  const returned = overlayValue(overlay.returned);
  if (submitted === "—" && returned !== "—") {
    return `${overlay.label}: Call uses "${returned}"`;
  }
  if (returned === "—" || submitted === returned) {
    return `${overlay.label}: ${submitted}`;
  }
  return `${overlay.label}: "${submitted}" → "${returned}"`;
}

export function StediSubscriberFields({
  overlays,
  className,
}: {
  overlays: StediSubscriberFieldOverlay[];
  className?: string;
}) {
  if (!overlays.length) {
    return null;
  }

  return (
    <div className={cn("mt-1 space-y-0.5", className)}>
      {overlays.map((overlay) => {
        const enriched =
          overlayValue(overlay.submitted) === "—" &&
          overlayValue(overlay.returned) !== "—";
        return (
          <div
            key={overlay.field}
            className={cn(
              "text-[11px] leading-snug",
              overlay.is_discrepancy
                ? "text-orange-800 dark:text-orange-200"
                : enriched
                  ? "text-muted-foreground"
                  : "text-muted-foreground",
            )}
            title={
              overlay.is_discrepancy
                ? `Operator "${overlay.submitted}" · Call uses "${overlay.returned}"`
                : enriched
                  ? `Call uses ${overlay.label.toLowerCase()} (operator left blank)`
                  : overlayLine(overlay)
            }
          >
            {overlayLine(overlay)}
          </div>
        );
      })}
    </div>
  );
}
